import { msg } from "shared/Messages";
import type { PermissionAction } from "shared/Permissions";
import type { ProjectSettings } from "shared/Project";
import { currentOrganisationPath, currentProjectPath } from "src/lib/PortalPaths";

/** Every project setting must register its destination; settings search consumes this catalog. */
export const PROJECT_SETTINGS_CATALOG = {
  aiMediaSearchEnabled: {
    path: currentProjectPath("/settings"),
    id: "ai-media-search",
    label: msg("AI Video & Audio Indexing"),
    description: msg(
      "AI asset search natural language semantic media audio speech video transcript indexing cost estimate enable",
    ),
    permission: "settings:read",
  },
  blockUnmoderatedAssets: {
    path: currentProjectPath("/settings"),
    id: "block-unmoderated-assets",
    label: msg("Block assets until moderation finishes"),
    description: msg("Stop block files public before moderation pending delivery"),
    permission: "settings:read",
  },
  storeSensitiveMetadata: {
    path: currentProjectPath("/settings"),
    id: "store-sensitive-metadata",
    label: msg("Store sensitive metadata"),
    description: msg("Image EXIF XMP IPTC GPS location camera serial creator privacy strip keep"),
    permission: "settings:read",
  },
  testInputsEnabled: {
    path: currentProjectPath("/settings"),
    id: "test-inputs",
    label: msg("Test inputs"),
    description: msg("Test images text codes media phrases trigger moderation testing"),
    permission: "settings:read",
  },
  remoteUrlRule: {
    path: currentProjectPath("/settings"),
    id: "remote-url-domains",
    label: msg("Accepted domains"),
    description: msg("Allow block deny list domains websites URLs submit restrict sites"),
    permission: "settings:read",
  },
  websiteSubmissionsPerMinute: {
    path: currentProjectPath("/settings"),
    id: "website-submission-rate",
    label: msg("Website submissions per minute"),
    description: msg("Rate limit websites per minute throttle browser render submissions"),
    permission: "settings:read",
  },
  jurisdictions: {
    path: currentProjectPath("/settings"),
    id: "jurisdictions-served",
    label: msg("Jurisdictions served"),
    description: msg("Regional mandatory rules viewer country age checks delivery"),
    permission: "settings:read",
  },
  moderationProfileId: {
    path: currentOrganisationPath("/moderation-policies"),
    id: "",
    label: msg("Moderation policies"),
    description: msg("Safety rules categories reject approve policy profile"),
    permission: "settings:read",
  },
  metadataFields: {
    path: currentProjectPath("/metadata"),
    id: "",
    label: msg("Metadata fields"),
    description: msg("Custom asset metadata field definitions"),
    permission: "metadata:read",
  },
  humanReview: {
    path: currentProjectPath("/human-review"),
    id: "",
    label: msg("Human review"),
    description: msg("Human review sampling reviewers"),
    permission: "settings:read",
  },
} as const satisfies Record<
  keyof ProjectSettings,
  {
    path: string;
    id: string;
    label: string;
    description: string;
    permission: PermissionAction;
  }
>;
